import React from 'react'
import { Image } from '@chakra-ui/react'
import PropTypes from 'prop-types'

Logo.propTypes = {
  width: PropTypes.any,
  rest: PropTypes.any,
}

function Logo({ width = 76, ...rest }) {
  return (
    <Image
      src="/assets/img/logos/cem/cem-logo-white.svg"
      w={width}
      {...rest}
    />
  )
}

export default Logo
